import loader from "../assets/Loader1.gif";
import "./css/Loader.css";



const Loader = () => {
  return (
    <div className="loader-overlay">
      <img src={loader} alt="Loading..." />
    </div>
  );
};

export default Loader;